export default __webpack_public_path__ + "assets/6dc97ef71c1dc3dc869062ed387eac10.jpeg";